import * as React from "react";
import { styled } from "@mui/system";
import MUITab, { TabProps } from "@mui/material/Tab";

export const Tab = styled((props: TabProps) => <MUITab {...props} />, {
  name: "Tab",
  slot: "Root",
  overridesResolver: (props, styles) => [],
})(({ theme }) => ({
  "&.MuiTab-root": {
    ...theme.typography["titleMedium"],
    color: theme.palette.primary.textSubduedColor,
    fontWeight: 600,
    paddingLeft: 24,
    paddingRight: 24,
    borderBottom: "4px solid transparent",
  },
  "&.MuiTab-root:hover": {
    ...theme.typography["titleMedium"],
    background: theme.palette.primary.interactiveDefault,
    color: theme.palette.primary.baseWhiteColor,
    fontWeight: 600,
  },
  "&.MuiTab-root.Mui-selected": {
    ...theme.typography["titleMedium"],
    color: theme.palette.primary.primary60Color,
    background: theme.palette.primary.background,
    borderBottom: "4px solid " + theme.palette.primary.borderActive,
  },
  "&.MuiTab-root.Mui-disabled": {
    cursor: "not-allowed",
    pointerEvents: "all !important",
    color: theme.palette.primary.textDisabledColor,
  },
  "&.MuiTab-root.Mui-disabled:hover": {
    background: "transparent",
  },
}));
